<template>
    <div class="row">
        <div class="col-xl-3 col-md-4 col-sm-6">
            <label class="w-100">
                {{ $t('modal.search.placeholder') }}
                <input class="w-100 form-control" type="text" v-model="fetch.params.search" @input="filterDataTimeout">
            </label>
        </div>
        <div class="col-xl-3 col-md-4 col-sm-6">
            <label class="w-100">
                {{ $t('modal.search.placeholder') }}
                <input class="w-100 form-control" type="date" v-model="fetch.pagination.date" @input="fetchData">
            </label>
        </div>
        <div class="col-xl-3 col-md-4 col-sm-6">
            <label class="w-100">
                {{ $t('modal.form.status.label') }}
                <v-select class="w-100 select-control" v-model="fetch.pagination.status" :options="options.status" :reduce="(options) => options.id" label="name" @input="fetchData"></v-select>
            </label>
        </div>
        <div class="col-xl-3 col-md-4 col-sm-6">
            <label class="w-100">
                {{ $t('data.driverWaterCount') }}
                <input class="w-100 form-control" type="text" v-model="round.isHave" disabled>
            </label>
        </div>
        <div class="col-xl-3 col-md-4 col-sm-6">
            <label class="w-100">
                Jami
                <input class="w-100 form-control" type="text" v-model="arrayFilter" disabled>
            </label>
        </div>
        <div class="col-12 d-md-flex w-100 d-none">
            <div class="_table w-100">
                <b-table :fields="fetch.fields" :items="fetch.items" :busy="fetch.loading">
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #cell(client)={item}>
                        <div v-for="(num, index) in item.client.numbers" :key="index">
                          <a style="color: black !important;" :href="`tel:+${num.mobile}`">{{ num.mobile | VMask('###(##) ### ## ##') }}</a>
                        </div>
                    </template>
                    <template #cell(actions)={item}>
                        <b-button
                            variant="success"
                            size="sm"
                            :disabled="round.isHave < item.quantity"
                            v-if="item.current_status.id === 2"
                            @click="deliveredModalOpen(item)"
                        >
                            <i class="bx bx-check-double fs-5"></i>
                        </b-button>
                        <b-button
                            variant="primary"
                            size="sm"
                            :disabled="round.isHave < item.quantity"
                            v-if="item.current_status.id === 6 "
                            @click="acceptModalOpen(item)"
                        >
                            <i class="bx bx-clipboard fs-5"></i>
                        </b-button>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="row d-md-none d-flex mt-3">
            <div class="col-md-6" v-for="(item, index) in fetch.items" :key="index">
                <div class="card">
                    <div class="card-body">
                        <div v-for="(field, idx) in fetch.fields" :key="idx">
                            <div class="d-flex align-items-center justify-content-between border-bottom border-2 py-1" v-if="field.label !== 'Telefon raqami' && field.label !== 'Harakatlar'">
                                <strong class="fs-5">{{field.label}}</strong>
                                <p class="mb-0 fs-5">{{item[field.key] === undefined ? checkItems(field.key, item) : item[field.key]}}</p>
                            </div>
                            <div class="d-flex align-items-center justify-content-between border-bottom border-2 py-1" v-else-if="field.label === 'Telefon raqami'">
                                <strong class="fs-5">{{field.label}}</strong>
                                <div v-for="(num, i) in item.client.numbers" :key="i">
                                    <a class="fs-5" style="color: black !important;" :href="`tel:+${num.mobile}`">{{ num.mobile | VMask('###(##) ### ## ##') }}</a>
                                </div>
                            </div>
                            <div v-else-if="field.label === 'Harakatlar'" class="pt-2 d-flex align-items-center justify-content-center">
                                <b-button
                                    variant="success"
                                    :disabled="round.isHave < item.quantity"
                                    v-if="item.current_status.id === 2"
                                    @click="deliveredModalOpen(item)"
                                >
                                    <i class="bx bx-check-double fs-5"></i>
                                </b-button>
                                <b-button
                                    variant="primary"
                                    :disabled="round.isHave < item.quantity"
                                    v-if="item.current_status.id === 6 "
                                    @click="acceptModalOpen(item)"
                                >
                                    <i class="bx bx-clipboard fs-5"></i>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <b-pagination
                v-model="fetch.pagination.page"
                :total-rows="fetch.total"
                :per-page="fetch.pagination.pageSize"
                @input="fetchData"
            ></b-pagination>
        </div>
        
        <b-modal v-model="getBottleBoll" hide-footer>
            <GetBottle @onClose="onClose" :ordersCount="ordersCount"/>
        </b-modal>
        <b-modal
            v-model="acceptModalBool"
            hide-footer
        >
            <AcceptModal @onClose="acceptModalClose" :item="orderInformation"/>
        </b-modal>
        <b-modal
            v-model="deliveredModalBool"
            hide-footer
        >
            <DeliveredModal @onClose="deliveredModalClose" :item="orderInformation"/>
        </b-modal>
    </div>
</template>

<script>
import GetBottle from './getBottle.vue';
import AcceptModal from './acceptModal.vue'
import DeliveredModal from './deliveredModal.vue';
import {getLeadOrders} from '@/api/endpoints/orders';
import {getActiveRounds} from "@/api/endpoints/active-rounds";
import moment from "moment";
import {getOrderStatus} from "@/api/endpoints/clients";

export default {
    name: "DriverQuery",
    components: {
        GetBottle,
        AcceptModal,
        DeliveredModal
    },
    data() {
        return {
            getBottleBoll: false,
            ordersCount: null,
            dataTimeout: null,
            acceptModalBool: false,
            orderInformation: {},
            deliveredModalBool: false,
            fetch: {
                items: [],
                fields: [
                    {key: "client.contract_number", label: "#"},
                    {key: "client.full_name", label: this.$t('table.clients')},
                    {key: "client.address", label: this.$t('table.address.label')},
                    {key: "client", label: this.$t('table.numbers.label')},
                    {key: "product.name", label: this.$t('table.product.label')},
                    {key: "current_status.name", label: this.$t('table.status.label')},
                    {key: "quantity", label: this.$t('table.quantity.label')},
                    {key: "client.driver.full_name", label: this.$t('data.ClientDriver')},
                    {key: "actions", label: this.$t('table.actions.label')}
                ],
                pagination: {
                    page: 1,
                    pageSize: 35,
                    addressSort: true,
                    date: '',
                    status: null,
                },
                params: {
                    search: null,
                },
                total: 1,
                loading: false
            },
            round: {
                items: {},
                isHave: 0,
                inOrder: 0,
            },
            options: {
                status: []
            },
            arrayFilter: null,
        }
    },
    mounted() {
        this.fetch.pagination.date = moment().format('YYYY-MM-DD');
        this.fetchData();
        getOrderStatus()
            .then(res => {
                this.options.status = [...res.data.data.filter(item => item.id === 3), ...res.data.data.filter(item => item.id === 4)];
            })
    },
    methods: {
        onGet(count) {
            this.ordersCount = count;
            this.getBottleBoll = true;
        },
        onClose() {
            this.getBottleBoll = false;
            this.fetchData();
        },
        filterDataTimeout() {
            clearTimeout(this.dataTimeout);
            this.dataTimeout = setTimeout(() => {
                this.fetchData(this.fetch.params.search)
            }, 800)
        },
        acceptModalOpen(item) {
            this.orderInformation = item;
            this.acceptModalBool = true;
        },
        acceptModalClose() {
            this.acceptModalBool = false;
            this.fetchData();
        },
        deliveredModalOpen(item) {
            this.orderInformation = item;
            this.deliveredModalBool = true;
        },
        deliveredModalClose() {
            this.deliveredModalBool = false;
            this.fetchData();
        },
        fetchData(param = null) {
            this.fetch.loading = true;
            var search1 = null;
            if (typeof param === 'string') {
                search1 = param
            }
            getLeadOrders({...this.fetch.pagination, search: search1})
            .then(response => {
                this.fetch.items = Object.values(response.data.data);
                this.fetch.total = response.data.total;
                if(this.fetch.pagination.status === null) {
                    // 2 6
                    // this.fetch.items =
                    let a = [...this.fetch.items.filter(item => item.status === 6), ...this.fetch.items.filter(item => item.status === 2)];
                    let b = a.filter(item => item.status === 2);
                    let d = a.filter(item => item.status === 6);
                    // eslint-disable-next-line no-console
                    console.log(d)
                    this.fetch.items = [...b, ...d];
                }
                this.fetchActiveRound();
                if (this.fetch.items.length) {
                    this.arrayFilter = this.fetch.items.map(item => item.quantity).reduce((a, b) => a+b)
                } else this.arrayFilter = 0;
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.log(err.response)
            })
            .finally(() => {
                this.fetch.loading = false;
            })
        },
        fetchActiveRound() {
            this.round.items = []
            this.round.inOrder = 0
            this.round.isHave = 0
            getActiveRounds()
                .then(responsive => {
                    let res = responsive.data.data
                    this.round.items = res;
                    if(res) {
                        this.round.inOrder = res.orders.map(el => el.count).reduce((a, b) => a + b, 0);
                        this.round.isHave = res.total_products_quantity - this.round.inOrder
                    } else {
                        this.round.isHave = this.$t('dispatcher.clients.errorMessage');
                        this.round.isHave = 0;
                    }
                })
        },
        checkItems(a, b) {
            let _f = a;
            let _i = {...b}
            let dodCount = 0;
            let objectKeys = {};
            let createObject = null;
        
            for (let i = 0; i < a.length; i++) if(a[i] === '.') dodCount++
            for (let i = 0; i <= dodCount ; i++) {
                if(i === dodCount) objectKeys[i] = _f
                else {
                    let idx = _f.indexOf('.');
                    objectKeys[i] = _f.slice(0, idx);
                    _f = _f.replace(`${_f.slice(0, idx)}.`, '')
                }
            }
            for (let i = 0; i <=dodCount ; i++) {
                if(i === 0) {
                    try {createObject = _i[objectKeys[i]]}
                    catch (error) {createObject = ''}
                } else {
                    try {createObject = createObject[objectKeys[i]]}
                    catch (error) {createObject = ''}
                }
            }
            return createObject
        },
    }
}
</script>
